import { AppState } from "@/store/appState/state";
import { State as RootState } from "@/store/state";

import { ActionContext } from "vuex";
import {
  commitDismissError,
  commitHasUnsavedChanges,
  commitRaiseError,
  commitSetErrorTimeout
} from "@/store/appState/mutations";
import { getStoreAccessors } from "typesafe-vuex";

type AppContext = ActionContext<AppState, RootState>;

export const actions = {
  async raiseError(context: AppContext, payload: Error) {
    commitRaiseError(context, payload);
  },

  async dismissError(context: AppContext) {
    commitDismissError(context);
  },

  async raiseErrorTimeout(context: AppContext, payload: Error) {
    commitRaiseError(context, payload);
    setTimeout(
      () => commitDismissError(context),
      context.rootGetters.getErrorTimeout
    );
  },

  async setErrorTimeout(context: AppContext, payload: number) {
    commitSetErrorTimeout(context, payload);
  },

  async unsavedChangesNotify(context: AppContext) {
    commitHasUnsavedChanges(context, true);
  },

  async resetUnsavedChangesState(context: AppContext) {
    commitHasUnsavedChanges(context, false);
  }
};

const { dispatch } = getStoreAccessors<AppState, RootState>("");

export const dispatchRaiseError = dispatch(actions.raiseError);
export const dispatchDismissError = dispatch(actions.dismissError);
export const dispatchRaiseErrorTimeout = dispatch(actions.raiseErrorTimeout);
export const dispatchUnsavedChangesNotify = dispatch(
  actions.unsavedChangesNotify
);
export const dispatchResetUnsavedChangesState = dispatch(
  actions.resetUnsavedChangesState
);
